import { AxiosRequestConfig } from 'axios';
import { ChangelogsRequestParams } from '../types';

export const getChangelog = (params: ChangelogsRequestParams): AxiosRequestConfig => ({
   url: `/mx/v1/changelog`,
   method: 'get',
   params,
});
